module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/images/clanUnitsFooter.95eaef97.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/images/clanUnitsFooter.png
// module id = 2797
// module chunks = 11